export default {
  email: 'Please verify the email is in a valid format',
}
